import React from 'react';
import { TopBar } from './components/TopBar';
import { WelcomeSection } from './components/WelcomeSection';
import { ComplianceGrid } from './components/ComplianceGrid';
import { HelpCTA } from './components/HelpCTA';
export function App() {
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      <TopBar businessName="TechCraft Solutions" data-id="element-1" />
      <main className="container mx-auto px-4 py-6 space-y-6 mb-16" data-id="element-2">
        <WelcomeSection businessName="TechCraft Solutions" progress={60} data-id="element-3" />
        <ComplianceGrid data-id="element-4" />
      </main>
      <HelpCTA data-id="element-5" />
    </div>;
}